import { t } from 'ember-intl';
import { HdsAlert } from '@hashicorp/design-system-components/components';

const AvoidDefaultRoleOrgLockout = <template>
  <HdsAlert
    data-test-sso-banner-avoid-default-role-org-lockout
    @type="inline"
    @color="warning"
    as |A|
  >
    <A.Title>
      {{t "sso.banner.avoid-default-role-org-lockout.title"}}
    </A.Title>

    <A.Description>
      <p>
        {{t
          "sso.banner.avoid-default-role-org-lockout.description"
          orgName=@organization.name
          htmlSafe=true
        }}
      </p>
      <p>
        {{t
          "sso.banner.avoid-default-role-org-lockout.next-steps"
          htmlSafe=true
        }}
      </p>
    </A.Description>
  </HdsAlert>
</template>;

export default AvoidDefaultRoleOrgLockout;
